<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <div class="row ptb20">
              <div class="col col-lg-4 col-md-6 col-sm-12">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  PARTNUMBER
                </div>

                <input
                  type="text"
                  pInputText
                  class="form-control form-control-sm"
                  placeholder="Informe o partnumber"
                  [(ngModel)]="filtros.partnumber"
                  (keyup.enter)="pesquisar()">
              </div>

              <div class="col col-lg-8 col-md-6 col-sm-12 mt-3">
                <div class="d-flex align-items-end justify-content-between flex-wrap">
                  <div class="d-flex flex-wrap">
                    <button type="button" class="btn btn-primary mr-2 mb-2" (click)="pesquisar()">
                      Filtrar
                      <i class="fas fa-search ml-1"></i>
                    </button>

                    <button type="button" class="btn btn-outline-secondary mr-2 mb-2" (click)="cleanFilter()">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>

                  <div class="d-flex">
                    <button
                      pButton
                      class="p-button-outlined p-button-secondary p-button-sm mb-2"
                      type="button"
                      (click)="exportExcel()">
                      <i class="fa fa-download mr-1"></i>Export Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr>

          </div>
        </div>
      </div>
    </div>

    <div class="mr-2 ml-2 background">
      <p-table
        [columns]="columns"
        [value]="data"
        class="style"
        [paginator]="data?.length > 0"
        [loading]="loading"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,20,30,50,100]"
        (sortFunction)="customSort($event)"
        [customSort]="true"
        (onPage)="onPageChange($event)"
        [first]="first"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        styleClass="p-datatable-striped p-datatable-sm"
        [rowHover]="true"
        id="excel-table"
        [autoLayout]="false"
        [scrollable]="true"
        scrollDirection="horizontal">

        <ng-template pTemplate="colgroup">
          <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th
                [ngStyle]="{'width': col.width}"
                class="text-center"
                [pSortableColumn]="col.field">
                {{ col.header }}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Sort" />
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data let-columns="columns">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td class="text-center">
                {{ data[col.field] || '-' }}
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="emptymessage mr-2 ml-2">
      <div *ngIf="data?.length === 0 && !loading" class="text-center">
        Nenhum registro encontrado.
      </div>
    </div>
  </div>
</div>